import { atom } from 'jotai';
import { ActivitySummary } from '../../data/datamonitorRepo';

export type ActivityState = {
    init: boolean;
    waiting: boolean;
    error: string | null;
    data: ActivitySummary;
};

export const emptyActivitySummary: ActivitySummary = {
    inbound: [],
    current: [],
    finished: [],
    reEval: [],
    other: [],
    locks: [],
};

export const activityStateAtom = atom<ActivityState>({
    init: true,
    waiting: false,
    error: null,
    data: emptyActivitySummary,
});
